import { analytics } from "@heycatch/sdk";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

if (process.env.NODE_ENV === "production") {
  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
  });

  analytics.init({
    projectKey: "hck_pk_pwUyIHvt8W5k7-kRzlHSUqXn-_V6n-ZO",
    install: { framework: "react", frameworkVersion: "18", agent: "other" },
  });

  const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <ErrorBoundary>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ErrorBoundary>,
  );
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
